<template>
  <div class="">


    <b-button v-b-modal.data-import pill>{{ buttonText }}</b-button>

    <b-modal id="data-import" hide-footer>


      <form @submit.prevent="submit">
        <h5 class="text-center mb-4">
          {{ buttonText }}
          <a :href="sampleFile" download>
            (نمونه فایل)
          </a>


        </h5>

        <form-group :validations="$v.form.data">
          <div slot-scope="{ errors, invalid }">
            <div class="custom-file">
              <input @change="handleFileUpload" type="file" class="custom-file-input" id="customFile">
              <label class="custom-file-label" for="customFile">انتخاب فایل</label>
            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <div class="progress-bar-section  d-none" ref="progress-bar-section">

          <div class=" mt-3 text-right" dir="rtl">
            <p style="flex: 0 0 100%;">تعداد ارسالی:
              {{ totalSend }}
            </p>
            <div class="d-flex justify-content-between">
              <b-progress style="flex: 0 0 88%;" max="100" :value="progressValue" :animated="true"
                          :show-value="true"></b-progress>
              <b-icon class="badge-danger rounded"
                      @click="cancelSendData()"
                      style="flex: 0 0 10%; display: flex; align-items: center; justify-content: center; cursor: pointer"
                      icon="x"/>
            </div>
          </div>
        </div>

        <div class="col-12 mt-3 text-center">
          <button class="btn btn-primary px-5 rounded-pill" ref="submit_button" type="submit">ثبت</button>
        </div>
      </form>

    </b-modal>


  </div>
</template>

<script>
import * as XLSX from "xlsx";
import {required, url} from "vuelidate/lib/validators";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

function chunkArray(array, size) {
  const result = []
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size))
  }
  return result
}


export default {
  name: "DataImportManager",
  components: {FormErrorsManager, FormGroup},
  props: {
    dataType: {
      default: 'user', // for now support: user, product and menu
    }
  },
  data() {
    return {
      form: {
        data: null,
        type: this.dataType,
      },
      progressValue: 0,
      totalSend: 0,
      cancelProcess: false
    };
  },
  validations: {
    form: {
      data: {required},
    },
  },
  computed: {
    buttonText() {
      switch (this.dataType) {
        case 'user':
          return 'افزودن دسته ای کاربر'
        case 'product':
          return 'افزودن دسته ای محصولات'
        case 'menu':
          return 'افزودن دسته ای منو'

        default:
          return 'یافت نشد.'
      }

    },
    sampleFile() {

      switch (this.dataType) {
        case 'user':
          return '/batch_users.xlsx'
        case 'product':
          return '/batch_products.xlsx'
        case 'menu':
          return '/batch_menus.xlsx'
        default:
          return '/'
      }

    }
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, {type: "array"});

          // Assuming the first sheet is the one you need
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];

          // Parse the sheet into JSON
          this.form.data = XLSX.utils.sheet_to_json(sheet, {defval: null});

        };
        reader.readAsArrayBuffer(file);
      }
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    cancelSendData() {
      this.cancelProcess = true;
    },
    reshapeProductForm() {
      this.form['data'].forEach(item => {

        if (item['category'] != undefined && item['category'] != null && item['category'].trim().length > 0) {
          // استخراج مقادیر مربوط به دسته‌بندی‌ها
          item['categories'] = item['category'].split(',').map(category => category.trim());
        } else {
          item['categories'] = []
        }

      })
    },
    async submit() {

      if (this.invalid()) {
        let submitButton = this.$refs.submit_button;
        let progress_bar_section = this.$refs['progress-bar-section'];
        submitButton.disabled = true;
        progress_bar_section.classList.toggle('d-none');

        if (this.dataType == 'product') {
          this.reshapeProductForm();
        }

        this.totalSend = 0;
        this.progressValue = 0;

        // منو نباید chunk شود تا همه آیتم‌ها در یک درخواست بروند
        let chunks = this.dataType === 'menu'
          ? [this.form['data']]
          : chunkArray(this.form['data'], 1);

        for (let index = 0; index < chunks.length; index++) {
          if (this.cancelProcess) {
            break
          }
          let part = {
            data: chunks[index],
            type: this.dataType
          };

          try {
            await this.$store.dispatch('DataImport/sendData', part); // انتظار برای ارسال
            this.progressValue = ((index + 1) * 100) / chunks.length; // بروزرسانی درصد
            this.totalSend += part.data.length; // بروزرسانی تعداد ارسال شده
          } catch (error) {
            toast(error, error)
          }
        }

        // اعلام موفقیت پس از پایان تمام درخواست‌ها
        toast(`عملیات با موفقیت انجام شد.`, `عملیات با موفقیت انجام شد.`);
        progress_bar_section.classList.toggle('d-none');
        submitButton.disabled = false;
        this.$emit('imported');
      }

    },
  }
}
</script>

<style scoped>

</style>